import React, { Component } from 'react';
import styled, { keyframes, css } from 'styled-components';
import device from '../../../Assets/Responsive/breakpoints';

const Container = styled.section`
  //   height: 40vh; /* Since pageSplitTime is 1.4 */
  height: 60vh; /* Since pageSplitTime is 1.4 */
  z-index: 1;
  width: 100%;
  @media ${device.laptop} {
    scroll-margin-top: 11rem;
  }
  @media ${device.laptopL} {
    scroll-margin-top: 10.5rem;
  }
  @media ${device.desktop} {
    scroll-margin-top: 13rem;
  }
  /* border: 1px solid blue; */
  position: relative;
`;

const AboutMeTitle = styled.div.attrs({
  style: ({ scrollPercent }) => ({
    transform: `translateX(${scrollPercent * 4}%)`
  })
})`
  transition: transform 0.5s ease-out;
  font-family: 'AvenirHeavy';
  position: absolute;
  color: #eee;
  top: 5%;
  left: -15%;

  @media ${device.mobileMaxWidth} {
    font-size: 60px;
  }
  //   @media ${device.laptopL} {
  font-size: 200px;
  //   }
  //   @media ${device.desktop} {
  //     font-size: 350px;
  //   }
`;

const AboutMeDescription = styled.div`
  align-items: center;
  font-family: 'AvenirLight';
  text-align: left;
  margin-left: 30%;
  margin-right: 5%;
  @media ${device.mobileMaxWidth} {
    transform: translateY(90%);
    font-size: 16px;
    text-align: center;
    margin-left: 3%;
    margin-right: 3%;
  }
  @media ${device.laptop} {
    transform: translateY(90%);
    font-size: 30px;
  }
  @media ${device.laptopL} {
    transform: translateY(87%);
    font-size: 38px;
  }
  @media ${device.desktop} {
    transform: translateY(80%);
    font-size: 70px;
  }
`;

const PopupText = styled.span`
  position: absolute;
  visibility: ${({ isScrolledTop }) => (isScrolledTop ? 'visible' : 'hidden')};
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  background-color: #c4c4c4;
  color: white;
  text-align: center;
  border-radius: 6px;
  padding: 4px 6px;
  position: absolute;
  z-index: 1;
  bottom: 6px;
  left: 250px;
  font-size: 1.5rem;
  &:after {
    content: '';
    position: absolute;
    top: 44%;
    left: -6%;
    border-width: 17px 4px 15px 15px;
    border-style: solid;
    border-color: #c4c4c4 transparent transparent transparent;
  }
`;
const fadeIn = keyframes`
from {opacity: 0;}
to {opacity:1 ;}
`;
const ButtonLink = styled.button`
  all: unset;
`;
const Link = styled.a`
  position: relative;
  text-decoration: none;
  ${({ isNotClicked, isScrolledTop }) =>
    isNotClicked &&
    !isScrolledTop &&
    css`
      pointer-events: none;
      cursor: default;
    `};
  color: #4682b4;
  ${({ isScrolledTop }) =>
    !isScrolledTop &&
    css`
      &:hover ${PopupText} {
        visibility: visible;
        -webkit-animation: ${fadeIn} 1s;
        animation: ${fadeIn} 1s;
      }
    `}
`;

class AboutMe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollPercent: 0,
      scrollTop: 0,
      isNotClicked: true
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const { body, documentElement } = event.srcElement;
    const sd = Math.max(body.scrollTop, documentElement.scrollTop);
    const sp = (sd / (documentElement.scrollHeight - documentElement.clientHeight)) * 100;

    const maxlimit = (documentElement.clientHeight * 150) / documentElement.scrollHeight;
    if (sp >= 0 && sp <= maxlimit) {
      this.setState({ scrollPercent: sp });
    }
    if (documentElement.scrollTop >= 6600) {
      this.setState({ scrollTop: documentElement.scrollTop });
    }
  }

  render() {
    const { scrollPercent, scrollTop, isNotClicked } = this.state;
    const isScrolledTop = scrollTop > 6600;
    return (
      <Container id="about">
        <AboutMeTitle scrollPercent={scrollPercent}>ABOUT ME</AboutMeTitle>
        <AboutMeDescription>
          Versatile product manager with software development experience.
          <br />
          Passionate about product creation, and new technologies.
          <br />
          Checkout the{' '}
          <ButtonLink isNotClicked={isNotClicked} onClick={() => this.setState({ isNotClicked: false })}>
            <Link
              isScrolledTop={isScrolledTop}
              isNotClicked={isNotClicked}
              href="https://dorbellmas3.netlify.app/"
              target="_blank"
              rel="noopenner"
            >
              previous-v3.0
              <PopupText isScrolledTop={isScrolledTop}>
                {isScrolledTop || isNotClicked ? 'Now you can !!!!' : 'Not now, later 🤓'}
              </PopupText>
            </Link>
          </ButtonLink>
        </AboutMeDescription>
      </Container>
    );
  }
}

export default AboutMe;
